import { announce } from "./announcer";
import { createStore } from "./store";

export interface ToastNotice {
  id: number;
  message: string;
}

export class ToastStore {
  readonly store = createStore<ToastNotice[]>([]);
  private seq = 0;

  show(message: string) {
    this.store.set((items) => [{ id: ++this.seq, message }, ...items].slice(0, 3));
    announce(message);
  }

  dismiss(id: number) {
    this.store.set((items) => items.filter((item) => item.id !== id));
  }

  clear() { this.store.set([]); }
}
